import './index.scss'

export const applyModernStyleToPlayerIfApplicable = (
  $elem,
  player,
  options,
  chromecastOptions
) => {
  if (!document.body.dataset.useModernVideoJsStyle) return
  $elem.closest('.video-js').addClass('video-js-modern')

  player.simplerSubtitleButton()

  if (chromecastOptions) {
    // Insert the chrome cast button before the playback rate button.
    // Might be a better idea to do this always (even on non-modern??)...
    const newIndex = player.controlBar
      .children()
      .indexOf(player.controlBar.getChild('PlaybackRateMenuButton'))
    if (newIndex) {
      chromecastOptions.buttonPositionIndex = newIndex + 1
    }
  }

  // Video.js doesn't offer a way to listen for when a menu becomes visible (on hover/keyboard navigation, etc.)
  // We use a intersection observer to detect when the menu becomes visible and scroll to the active item (unless we already did so recently)
  player.ready(() => {
    const playbackRateMenu = player.controlBar
      .el()
      .querySelector('.vjs-playback-rate .vjs-menu-content')
    if (!playbackRateMenu) return
    let previouslyIntersecting = false
    let previouslyIntersectingTimeout = null
    const autoScrollToActiveMenuItem = (entries) => {
      const entry = entries[0]
      if (!previouslyIntersecting && entry.isIntersecting) {
        previouslyIntersecting = true
        const selectedItem = playbackRateMenu.querySelector('.vjs-selected')
        if (selectedItem)
          playbackRateMenu.scrollTop = selectedItem.offsetTop - 10
      } else {
        clearTimeout(previouslyIntersectingTimeout)
        previouslyIntersectingTimeout = setTimeout(
          () => (previouslyIntersecting = false),
          5000
        )
      }
    }
    const observer = new IntersectionObserver(autoScrollToActiveMenuItem)
    observer.observe(playbackRateMenu)
  })

  // Move the videojs-httpsource-selector button to be before the PiP toggle
  // It doesn't offer a way to specify where it should be inserted (like the chromecase button above), so we have to do it manually
  player.on('loadedmetadata', () => {
    setTimeout(() => {
      const controlBar = player.controlBar
      const qualitySwitcher = controlBar.getChild('SourceMenuButton')
      const pip = controlBar.getChild('PictureInPictureToggle')
      if (!qualitySwitcher || !pip) return

      player.controlBar.el().insertBefore(qualitySwitcher.el(), pip.el())
    }, 0)
  })
}
